export default "__VITE_ASSET__$EvZH4cZ__"